module.exports = "<!-- View/routes wrapper-->\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/layouts/blankLayout.template.html
// module id = ./src/app/components/common/layouts/blankLayout.template.html
// module chunks = main